export default __webpack_public_path__ + "static/media/trophy.86310d3e.png";